const toCharList = (value) => {
  return value.replace(/(.)(?=[^$])/g, "$1,").split(",")

}
export {
    toCharList
}
